import { Role } from 'constants/roles';

import { RaRecord, useListContext } from 'react-admin';
import { FormProvider } from 'react-hook-form';
import { FilterBar, FilterBarActions, FilterBarRow } from 'shared/mui/Filter/FilterBar';
import { FilterApplyButton, FilterResetButton } from 'shared/mui/Filter/FilterButtons';
import { useFilters } from 'shared/mui/Filter/hooks/useFilters';
import { useSyncFilter } from 'shared/mui/Filter/hooks/useSyncFilter';
import {
  AutocompleteInput,
  AutocompleteMultiselectInput,
  TextInput,
} from 'shared/react-admin/Inputs';
import { ReferenceArrayInput, ReferenceInput } from 'shared/react-admin/ReferenceInputs';
import { User } from 'types/embedded/user';

type WorkMemberFilterValues = {
  name: string;
  countries: string[];
  manager: string;
  members: string[];
};

const DEFAULT_VALUES: WorkMemberFilterValues = {
  name: '',
  countries: [],
  manager: '',
  members: [],
};

export const WorkTeamsListFilter: React.FC = () => {
  const { filterValues } = useListContext();
  const { form, onReset, onSubmit, appliedFilters } = useFilters<WorkMemberFilterValues>({
    defaultValues: { ...DEFAULT_VALUES, ...filterValues },
    resetValues: DEFAULT_VALUES,
  });

  useSyncFilter<WorkMemberFilterValues>({ appliedFilters });

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <FilterBar>
          <FilterBarRow sx={{ gridTemplateColumns: 'repeat(4, 1fr) 272px' }}>
            <TextInput
              helperText={false}
              label="Название группы"
              name="name"
              source="name"
              variant="outlined"
            />
            <ReferenceArrayInput perPage={200} reference="countries" source="countries">
              <AutocompleteMultiselectInput
                helperText={false}
                label="Страны"
                name="countries"
                optionText="name"
                size="small"
              />
            </ReferenceArrayInput>
            <ReferenceInput
              filter={{ 'roleEntities.alias': [Role.FinanceLead] }}
              perPage={50}
              reference="users"
              source="manager"
            >
              <AutocompleteInput
                filterToQuery={(searchText: string) => ({ fullName: searchText })}
                helperText={false}
                label="Руководитель группы"
                name="manager"
                optionText={(record: RaRecord) =>
                  record && `${record.firstName} ${record.lastName}`
                }
                size="small"
                variant="outlined"
              />
            </ReferenceInput>
            <ReferenceArrayInput
              filter={{
                'roleEntities.alias': [Role.Finance],
              }}
              perPage={200}
              reference="users"
              source="members"
            >
              <AutocompleteMultiselectInput
                filterToQuery={(searchText: string) => ({
                  fullName: searchText,
                })}
                getOptionLabel={(record: User) => `${record.firstName} ${record.lastName}`}
                helperText={false}
                label="Сотрудники"
                name="members"
                size="small"
              />
            </ReferenceArrayInput>
            <FilterBarActions>
              <FilterResetButton onReset={onReset} />
              <FilterApplyButton type="submit" />
            </FilterBarActions>
          </FilterBarRow>
        </FilterBar>
      </form>
    </FormProvider>
  );
};
